export default __webpack_public_path__ + "static/media/press-release.408e449f.svg";